<template>
  <div class="sideContent">
    <sliderProject></sliderProject>
  </div>
</template>
<script>
import sliderProject from './Sidebar.vue'
import sliderAdmin from '../admin/components/adminSliderBar'
export default {
  components: {
    sliderAdmin,
    sliderProject
  }
}
</script>
<style lang="scss">
  .sideContent {
    box-shadow: 2px 0 6px rgba(0,21,41,.35);
  }
</style>



// WEBPACK FOOTER //
// src/views/firmiana/layout/sliderWhich.vue